module.exports = __webpack_public_path__ + "static/img/index1.f0830b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index1.png
// module id = 53jR
// module chunks = 1